var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12082_1143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 22.0004C23.9283 22.0004 24.8185 21.6317 25.4749 20.9753C26.1313 20.3189 26.5 19.4287 26.5 18.5004C26.5 17.5721 26.1313 16.6819 25.4749 16.0255C24.8185 15.3692 23.9283 15.0004 23 15.0004H22C22.397 13.2324 21.715 11.4074 20.212 10.2134C18.709 9.02041 16.612 8.63841 14.712 9.21341C12.812 9.78841 11.397 11.2324 11 13.0004C8.80101 12.9124 6.84501 14.3264 6.33401 16.3734C5.82201 18.4204 6.89801 20.5274 8.90001 21.4004",
    stroke: "#62636C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20C12 19.7348 12.1054 19.4804 12.2929 19.2929C12.4804 19.1054 12.7348 19 13 19H19C19.2652 19 19.5196 19.1054 19.7071 19.2929C19.8946 19.4804 20 19.7348 20 20V23C20 23.2652 19.8946 23.5196 19.7071 23.7071C19.5196 23.8946 19.2652 24 19 24H13C12.7348 24 12.4804 23.8946 12.2929 23.7071C12.1054 23.5196 12 23.2652 12 23V20Z",
    stroke: "#62636C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19V17C14 16.4696 14.2107 15.9609 14.5858 15.5858C14.9609 15.2107 15.4696 15 16 15C16.5304 15 17.0391 15.2107 17.4142 15.5858C17.7893 15.9609 18 16.4696 18 17V19",
    stroke: "#62636C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12082_1143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.aed8a4c8c8ec432978ed5d31fe35c90a.svg";
export { ForwardRef as ReactComponent };